import { render, staticRenderFns } from "./recommended.vue?vue&type=template&id=2be5511a&scoped=true"
import script from "./recommended.vue?vue&type=script&lang=ts"
export * from "./recommended.vue?vue&type=script&lang=ts"
import style0 from "./recommended.vue?vue&type=style&index=0&id=2be5511a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5511a",
  null
  
)

export default component.exports